import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import CsiFormData from "csi/action/FormData";
import { Actions } from "csi/def/Actions";
import { View } from "csi/def/View";
import PostRequest from "csi/comm/PostRequest";
import Query from "csi/xml/Query";
import xml from "csi/xml";
import { ViewWidget } from "csi/view/Widget";

const PreviewController = declare(Controller, {

	/**
	 * @override
	 * Set the parameters & call DGaaS PreviewDocument operation
	 */
	process() {
		const cache = this.getCache();
		const dGaaSOwner = cache.getNode(this.m_urlNode);
		let dGaaSTemplateRevisionUrl: string;
		let dGaaSTemplateRevisionId: string;
		if (dGaaSOwner.$Type === "DGaaSTemplateRevision") {
			dGaaSTemplateRevisionUrl = dGaaSOwner.$URL;
			dGaaSTemplateRevisionId = dGaaSOwner.Id;
		} else {
			const dGaaSTemplateRevision = cache.getNode(dGaaSOwner.LatestRevision);
			dGaaSTemplateRevisionUrl = dGaaSTemplateRevision.$URL;
			dGaaSTemplateRevisionId = dGaaSTemplateRevision.Id;
		}
		const selectedNode = this.getFormData().getSelectedNode();
		const req = new PostRequest("DocumentGenerator", "PreviewDocument");
		req.addParameter("DGaaSTemplateRevision", dGaaSTemplateRevisionUrl);
		req.addParameter("ParentURL", selectedNode.$URL);
		if (dGaaSTemplateRevisionId.includes(".xlsx")) {
			req.addParameter("DocumentType", "DGaaSGeneratedDocumentType:Excel");
		} else {
			req.addParameter("DocumentType", "DGaaSGeneratedDocumentType:PDF");
		}
		this.waitForPublish(req.post());
	},

	/**
	 * @override
	 * Replace "Save" button text with "Preview" & disable Preview button by passing true as a second param
	 * @param defView
	 * @param defActions
	 */
	addProxyActions(defView: View, defActions: Actions): void {
		defActions.addAction(this.getProxyAction("Preview", true, { m_bSubmit: true }));
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Only one selection is allowed in the view using radio button
	 */
	onFormData(fd: CsiFormData): void {
		fd.m_bRequireOne = true;
		fd.m_bSelectOne = true;
	},

	/**
	 * @override
	 * Apply an additional filter when clicking Preview.
	 * Display only nodes that belong to the subtype set on the DGaaSTemplate.
	 */
	applyActionFilters(view: ViewWidget) {
		const dGaaSTemplate = this.getNode();
		const primarySubtype = dGaaSTemplate.PrimarySubtype;
		const isProductType = ["Style", "Material"].includes(dGaaSTemplate.PrimaryType);
		if (xml.isValidURL(primarySubtype)) {
			const query = new Query();
			query.RefAttr(isProductType ? "ProductType" : "Subtype", xml.OP_EQUALS, primarySubtype);
			view.relRoot.addQuery(query);
		}
		this.inherited(arguments);
	},
});

export = PreviewController;

